/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentUpgradeStatusEnum } from './deploymentUpgradeStatusEnum';


export interface VcdsDeploymentVersion { 
    /**
     * Current deployment version
     */
    current_version?: string;
    upgrade_eligible?: DeploymentUpgradeStatusEnum;
    /**
     * Release Type
     */
    release_type?: string;
    /**
     * Release Type
     */
    upgradable_version?: string;
    /**
     * Is upgrade in progress
     */
    upgrade_in_progress?: boolean;
}
export namespace VcdsDeploymentVersion {
}


